import IUser from '../interfaces/IUser';
import UserRoles from '../data/UserRoles';

const UnregisteredUser: IUser = {
    id: '0',
    username: 'UnregisteredUser',
    displayName: 'Guest User',
    password: '',
    role: UserRoles.unregistered
  };

  export default UnregisteredUser;